import { render, staticRenderFns } from "./MenuGestioneFatture.vue?vue&type=template&id=a54d979c&"
import script from "./MenuGestioneFatture.vue?vue&type=script&lang=js&"
export * from "./MenuGestioneFatture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports